import React from 'react';
import { get } from 'lodash-es';

import { Layout, TitleBar, Card, TextFieldWithLabel } from '../components/library-components';
import OrganizationSubscriptionMembers from './organization_subscription_members';
import AddOrgSubscriptionMember from './add_org_subscription_member';
import ImportMemberCsv from './import_member_csv';

import { getOrganization, getSubscriptionById, getSubscriptionMembers, deleteMembersFromSubscription } from '../api';

class OrganizationSubscriptions extends React.Component {
  constructor () {
    super();
    this.state = {
      organization: {},
      subscriptionMembers: []
    };
  }

  componentDidMount () {
    getOrganization(this.props.organizationId)
      .then(({ organization }) => this.setState({ organization }, () => { this.getOrganizationSubscriptions(); this.getSubscriptionMembers(); }));
  }

  getOrganizationSubscriptions () {
    getSubscriptionById(this.props.subscriptionId)
      .then(({ subscriptions }) => this.setState({ orgSubscriptions: subscriptions[0] }));
  }

  getSubscriptionMembers (page = 1) {
    getSubscriptionMembers(this.primaryUser(), this.props.subscriptionId, page)
      .then((response) => {
        const subscriptionMembers = response.members.map(subscriber => {
          const subscriberEmailIdentities = subscriber.subscriber_identities.filter(identity => identity.provider === 'email');
          return { id: subscriber.id, name: get(subscriber, 'name', ''), email: get(subscriberEmailIdentities, [0, 'value'], ''), checked: false };
        });
        this.setState({ subscriptionMembers, totalPages: response.total_pages, totalEntries: response.total_entries });
      });
  }

  handlePageChange (page) {
    this.getSubscriptionMembers(page);
  }

  primaryUser () {
    return ({ provider: 'email', identity: this.state.organization.primary_email });
  }

  deleteMembers (id) {
    const memberIds = id ? [id] : this.state.subscriptionMembers.filter(member => member.checked).map(member => member.id);
    deleteMembersFromSubscription(this.primaryUser(), this.props.subscriptionId, memberIds)
      .then(() => this.getSubscriptionMembers());
  }

  toggleAllMemberSelection (checked) {
    this.setState({ subscriptionMembers: this.state.subscriptionMembers.map(x => (Object.assign({}, x, { checked }))) });
  }

  toggleMemberSelection (member, i) {
    const subscriptionMembers = this.state.subscriptionMembers;
    subscriptionMembers[i] = (Object.assign({}, member, { checked: !member.checked }));
    this.setState({ subscriptionMembers });
  }

  isAnyMemberSelected () {
    return this.state.subscriptionMembers.some(member => member.checked);
  }

  render () {
    return (
      <Layout>
        <TitleBar
          title='Edit subscription'
          breadcrumbTitle={this.state.organization.name}
          breadcrumbPath={`/organizations/${this.props.organizationId}`}
        />
        {this.state.orgSubscriptions &&
          <>
            <Card>
              <div className='form-row'>
                <TextFieldWithLabel
                  label='Subscription group'
                  value={this.state.orgSubscriptions.group_name}
                  dataTest='subscription-group'
                  disabled
                />
                <TextFieldWithLabel
                  label='Subscription plan'
                  value={this.state.orgSubscriptions.plan_name}
                  dataTest='subscription-plan'
                  disabled
                />
              </div>
              <div className='form-row'>
                <TextFieldWithLabel
                  label='Amount Paid'
                  value={`${this.state.orgSubscriptions.payment_amount_cents / 100} ${this.state.orgSubscriptions.payment_amount_currency}`}
                  dataTest='amount-paid'
                  disabled
                />
                <TextFieldWithLabel
                  label='User limit'
                  value={this.state.orgSubscriptions.user_limit}
                  dataTest='user-limit'
                  disabled
                />
              </div>
              {this.state.orgSubscriptions.notes &&
                <TextFieldWithLabel
                  label='Notes'
                  value={this.state.orgSubscriptions.notes}
                  dataTest='notes'
                  disabled
                />}
            </Card>
            <AddOrgSubscriptionMember
              primaryUser={this.primaryUser()}
              subscriptionId={this.props.subscriptionId}
              onAddingMember={() => this.getSubscriptionMembers()}
            />
            <OrganizationSubscriptionMembers
              members={this.state.subscriptionMembers}
              deleteMembers={id => this.deleteMembers(id)}
              toggleAllMemberSelection={checked => this.toggleAllMemberSelection(checked)}
              toggleMemberSelection={(member, i) => this.toggleMemberSelection(member, i)}
              someMembersSelected={this.isAnyMemberSelected()}
              pageCount={this.state.totalPages}
              totalEntries={this.state.totalEntries}
              onPageChange={page => this.handlePageChange(page)}
            />
            <ImportMemberCsv
              subscriptionId={this.props.subscriptionId}
              reloadMembers={() => this.getSubscriptionMembers()}
            />
          </>}
      </Layout>
    );
  }
}

export default OrganizationSubscriptions;
